// (C) Copyright 2024 Hewlett Packard Enterprise Development LP
import { Box } from 'grommet'
import { LineChart } from 'grommet-icons'
import PropTypes from 'prop-types'

import { Typography } from '../../../../../components'

import SuggestionContainer from './SuggestionContainer'

const PopularSearches = ({ query, index, t }) => {
  return (
    <SuggestionContainer>
      <Box direction="column" gap="small">
        {index === 0 && (
          <Typography type="text" size="xsmall">
            {t('popular_searches')}
          </Typography>
        )}
        <Box direction="row" gap="small">
          <Box pad={{ top: 'xxsmall' }}>
            <LineChart />
          </Box>
          <Typography type="text" weight={500}>
            {query}
          </Typography>
        </Box>
      </Box>
    </SuggestionContainer>
  )
}

PopularSearches.propTypes = {
  query: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired
}

export default PopularSearches
